/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ScoreInputs */

const th_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนน`)
};

const en_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const ja_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スコア`)
};

const zh_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比分`)
};

const es_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultado`)
};

const pt_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Placar`)
};

const id_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor`)
};

const fr_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const tl_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iskor`)
};

const vi_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tỉ số`)
};

const ko_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`점수`)
};

const de_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnis`)
};

const ru_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Счёт`)
};

const tr_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor`)
};

const it_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio`)
};

const pl_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynik`)
};

const uk_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рахунок`)
};

const hi_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्कोर`)
};

const ar_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النتيجة`)
};

const ms_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mata`)
};

const bn_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোর`)
};

const zh_tw2_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比分`)
};

const zh_hk2_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比分`)
};

const ur_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکور`)
};

const fa_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نتیجه`)
};

const sw_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matokeo`)
};

const nl_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand`)
};

/**
* | output |
* | --- |
* | "Score" |
*
* @param {ScoreInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const score = /** @type {((inputs?: ScoreInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ScoreInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_score(inputs)
	if (locale === "ja") return ja_score(inputs)
	if (locale === "zh") return zh_score(inputs)
	if (locale === "es") return es_score(inputs)
	if (locale === "pt") return pt_score(inputs)
	if (locale === "id") return id_score(inputs)
	if (locale === "fr") return fr_score(inputs)
	if (locale === "tl") return tl_score(inputs)
	if (locale === "vi") return vi_score(inputs)
	if (locale === "ko") return ko_score(inputs)
	if (locale === "de") return de_score(inputs)
	if (locale === "ru") return ru_score(inputs)
	if (locale === "tr") return tr_score(inputs)
	if (locale === "it") return it_score(inputs)
	if (locale === "pl") return pl_score(inputs)
	if (locale === "uk") return uk_score(inputs)
	if (locale === "hi") return hi_score(inputs)
	if (locale === "ar") return ar_score(inputs)
	if (locale === "ms") return ms_score(inputs)
	if (locale === "bn") return bn_score(inputs)
	if (locale === "zh-TW") return zh_tw2_score(inputs)
	if (locale === "zh-HK") return zh_hk2_score(inputs)
	if (locale === "ur") return ur_score(inputs)
	if (locale === "fa") return fa_score(inputs)
	if (locale === "sw") return sw_score(inputs)
	if (locale === "nl") return nl_score(inputs)
	return en_score(inputs)
});